import { render, staticRenderFns } from "./clothesList.vue?vue&type=template&id=4f7c13c7&scoped=true&"
import script from "./clothesList.vue?vue&type=script&lang=js&"
export * from "./clothesList.vue?vue&type=script&lang=js&"
import style0 from "./clothesList.vue?vue&type=style&index=0&id=4f7c13c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c13c7",
  null
  
)

export default component.exports